import { http } from "../http/Http";
import { FieldDataType } from "../models/FieldDataType";
import { ServiceResponse } from "../models/ServiceResponse";

export class FieldDataTypeService {

    getFieldDataTypes = async (): Promise<ServiceResponse<FieldDataType[]>> => {
        const { data } = await http.get<ServiceResponse<FieldDataType[]>>("FieldDataType/GetAll");
        return data;
    };
}